import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { rfqAction } from "../../redux/actions";
import { toast } from "react-toastify";

const RfqComponent = () => {
  const [error, setError] = useState(null);
  const user = useSelector((state) => state?.user_data);
  const currency = user?.user_data?.company?.currency?.value;
  const location = useLocation();

  const [locat, setLocat] = useState("1");
  const [help, setHelp] = useState(false);
  const [compname, setCompname] = useState("");
  const [contperson, setContperson] = useState("");
  const [areacode, setAreacode] = useState("+971");
  const [phno, setPhno] = useState("");
  const [email, setEmail] = useState("");
  const [cmts, setCmts] = useState("");
  const [frequencies, setFrequencies] = useState({});
  const [rfqaction, setRfqaction] = useState();
  const [rfqutput, setRfqutput] = useState();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  let passedData = {};
  let rfq_data = {};
  let rfq_list = [];

  if (location?.state) {
    passedData = location?.state;
    rfq_data = passedData.myData || {};

    rfq_list = [rfq_data];
  }

  // Load RFQ list from local storage
  const [storedRFQList, setStoredRFQList] = useState(() => {
    return JSON.parse(localStorage.getItem("rfq_list")) || [];
  });

  // Add new product only if it doesn't exist (based on productID)
  useEffect(() => {
    if (rfq_list.length > 0) {
      const newProduct = rfq_list[0]; // Get the new product

      // Find if the product already exists
      const existingProductIndex = storedRFQList.findIndex(
        (item) => item.code === newProduct.code
      );

      let updatedList = [...storedRFQList];

      if (existingProductIndex !== -1) {
        // If the product exists, update its quantity
        updatedList[existingProductIndex] = {
          ...updatedList[existingProductIndex],
          quantity:
            updatedList[existingProductIndex].quantity + newProduct.quantity,
        };
      } else {
        // If the product does not exist, add it to the list
        updatedList.push(newProduct);
      }

      // Update state and local storage
      setStoredRFQList(updatedList);
      localStorage.setItem("rfq_list", JSON.stringify(updatedList));
    }
  }, [location?.state, rfq_list, storedRFQList]); // Trigger when location.state changes

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("rfq_list")) || [];
    if (storedData.length > 0) {
      const formattedData = storedData.map((product, index) => ({
        id: index + 1, // Unique ID
        image:
          product?.image || "/public/assets/images/logo/Image-coming-soon.png",
        name: product?.rfq_name || "Unnamed Product",
        quantity: product?.quantity, // Default quantity
        price: parseFloat(product?.price) || 0,
        code: product?.code,
      }));

      setStoredRFQList(formattedData); // Update state with formatted data
    }
  }, []);

  const handleDelete = (productid) => {
    setStoredRFQList((prevList) => {
      const updatedList = prevList.filter((item) => item.id !== productid);

      // Update local storage
      localStorage.setItem("rfq_list", JSON.stringify(updatedList));

      // Dispatch a custom event to notify other components
      window.dispatchEvent(new Event("rfqListUpdated"));

      return updatedList;
    });
  };

  const handleIncrement = (productid) => {
    setStoredRFQList((prevList) => {
      const updatedList = prevList.map((item) =>
        item.id === productid ? { ...item, quantity: item.quantity + 1 } : item
      );

      localStorage.setItem("rfq_list", JSON.stringify(updatedList));

      return updatedList;
    });
  };

  const handleDecrement = (productid) => {
    setStoredRFQList((prevList) => {
      const updatedList = prevList.map((item) => {
        if (item.id === productid) {
          if (item.quantity <= 1) {
            return item; // Do not decrement below 1
          }

          return { ...item, quantity: item.quantity - 1 };
        }

        return item;
      });

      localStorage.setItem("rfq_list", JSON.stringify(updatedList));
      return updatedList;
    });
  };

  // Handle frequency selection
  const handleFrequencyChange = (itemId, event) => {
    const selectedValue = event.target.value;

    // Update state
    setFrequencies((prev) => {
      const updatedFrequencies = { ...prev, [itemId]: selectedValue };

      // Save to localStorage
      localStorage.setItem("frequencies", JSON.stringify(updatedFrequencies));

      return updatedFrequencies;
    });
  };
  useEffect(() => {
    const savedFrequencies = JSON.parse(localStorage.getItem("frequencies"));

    if (savedFrequencies) {
      setFrequencies(savedFrequencies);
    }
  }, []);

  const collectRFQData = () => {
    if (!compname) {
      toast.error("Company name is required!");
    } else if (!contperson) {
      toast.error("Contact person is required!");
    } else if (!phno) {
      toast.error("Phone number is required!");
    } else if (
      typeof phno === "string" &&
      phno.length !== 8 &&
      phno.length !== 9
    ) {
      toast.error("Phone number must be exactly 8 or 9 digits!");
      return false;
    } else if (!email) {
      toast.error("Email is required!");
    } else if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address!");
      return false;
    } else {
      const rfqData = storedRFQList.map((item) => ({
        code: item.code, // Assuming each item has a `code` field
        qty: item.quantity,
        frequency: frequencies[item.id] || "weekly", // Default to "Weekly" if not selected
      }));
      setRfqaction(rfqData);
    }
  };

  const form_data = {
    area_code: areacode,
    comments: cmts,
    company_name: compname,
    contact_email: email,
    contact_name: contperson,
    need_help_with_quantities: help,
    nr_of_locations: locat,
    phone_number: phno,
    products: rfqaction,
    rfq_type: "rfq",
    status: "pending",
  };

  useEffect(() => {
    const fetchOrders = async () => {
      if (rfqaction && rfqaction.length > 0) {
        try {
          const data = await rfqAction(form_data);

          setRfqutput(data?.message || data || []);
          if (data?.message === "Quote request sent") {
            localStorage.removeItem("rfq_list");
            setStoredRFQList([]);
          }
        } catch (err) {
          setError(err.message);
        }
      }
    };
    fetchOrders();
  }, [rfqaction, form_data]);

  console.log(storedRFQList);

  return (
    <section className="hot-deals pt-20">
      {/* component 1 about us*/}
      <div className="container container-lg">
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8">
            <h2 className="mb-0 text-blue">REQUEST FOR QUOTE</h2>
          </div>
        </div>
      </div>

      {rfqutput === "Quote request sent" && (
        <div className="container container-lg">
          <div className="row gy-4">
            <div className="col-lg-12">
              <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                <div className="d-flex justify-content-center align-items-center text-black">
                  <img
                    style={{ width: "100px" }}
                    src="/assets/images/logo/tick.jpg"
                    alt=""
                  ></img>
                </div>

                <h4 className="center">Thank you</h4>
                <div className="d-flex justify-content-center align-items-center text-black">
                  <p className="text-center">
                    Your request for quote was successfully sent.
                    <br />
                    The salesperson will get in touch with you in 2 working
                    days.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {rfqutput !== "Quote request sent" && storedRFQList?.length === 0 && (
        <div className="container container-lg">
          <div className="row gy-4">
            <div className="col-lg-12">
              <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                <h5>You have no items in your request cart.</h5>
                <ul className="list-unstyled">
                  <li className="d-flex align-items-start text-black">
                    <span className="me-2 ">•</span>{" "}
                    <a style={{ color: "#0d55a3" }} href="/" target="_blank">
                      Browse our e-shop
                    </a>
                    &nbsp; and find the product you need.
                  </li>
                  <br></br>
                  <li className="d-flex align-items-start text-black">
                    <span className="me-2">•</span> Push the “Request quote”
                    button.
                  </li>
                  <br></br>
                  <li className="d-flex align-items-start text-black">
                    <span className="me-2">•</span> The product will be added
                    here.
                  </li>
                  <br></br>
                  <li className="d-flex align-items-start text-black">
                    <span className="me-2">•</span> Repeat for adding more
                    products.
                  </li>
                </ul>
                <br></br>
                <div className="py-100">
                  <h6 className="text-black ">
                    If you need help with selecting the products you need, get
                    in touch.
                  </h6>
                  <button className="btn hover-bg-main-600 hover-text-white py-11 px-24 flex-center gap-8">
                    Send request for
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {storedRFQList?.length > 0 && (
        <div className="container container-lg">
          <div className="row gy-4">
            <div className="col-lg-8">
              <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                <div className="d-none d-md-block">
                  <table
                    className="table w-100 rounded-8 overflow-hidden"
                    style={{ tableLayout: "fixed" }}
                  >
                    <thead>
                      <tr className="border-bottom border-neutral-100">
                        <th style={{ width: "10%" }} className="px-3 py-2">
                          Image
                        </th>
                        <th style={{ width: "17%" }} className="px-3 py-2">
                          Product Name
                        </th>
                        <th style={{ width: "22%" }} className="px-3 py-2">
                          Quantity
                        </th>
                        <th style={{ width: "18%" }} className="px-3 py-2">
                          Price
                        </th>
                        <th style={{ width: "18%" }} className="px-3 py-2">
                          How frequently
                        </th>
                        <th style={{ width: "15%" }} className="px-3 py-2">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {storedRFQList.length > 0 &&
                        storedRFQList.map((item, index) => (
                          <tr
                            className="border-bottom border-neutral-100"
                            key={item.id}
                          >
                            <td className="px-3 py-2">
                              <Link to="#">
                                <img
                                  src={item?.image}
                                  alt=""
                                  style={{ width: "50px", height: "50px" }}
                                />
                              </Link>
                            </td>
                            <td className="px-3 py-2">
                              <p
                                className="title fw-semibold mb-1"
                                style={{
                                  wordWrap: "break-word",
                                  whiteSpace: "normal",
                                }}
                              >
                                {item.name}
                              </p>
                            </td>
                            <td className="px-32 py-2">
                              <div className="d-flex align-items-center gap-2">
                                <button
                                  className={`w-32 h-32 text-white text-xl flex-center rounded-circle
      ph ph-minus
      ${
        item.quantity === 1
          ? "bg-light-grey cursor-not-allowed"
          : "bg-main-600 hover-bg-main-600 hover-text-white"
      }
    `}
                                  onClick={() => handleDecrement(item.id)}
                                  disabled={item.quantity === 1}
                                ></button>

                                {/* Quantity Display */}
                                <span
                                  className="fw-semibold text-center d-inline-block"
                                  style={{ width: "40px" }}
                                >
                                  {item.quantity}
                                </span>

                                {/* Increment Button */}
                                <button
                                  className={`w-32 h-32 text-white text-xl flex-center rounded-circle
      ph ph-plus
      ${"bg-main-600 hover-bg-main-600 hover-text-white"}
    `}
                                  onClick={() => handleIncrement(item.id)}
                                ></button>
                              </div>
                            </td>

                            <td className="px-3 py-2">
                              <span
                                className="fw-semibold"
                                style={{ color: "#0d55a3" }}
                              >
                                {currency} {item.price}
                              </span>
                            </td>
                            <td className="px-3 py-2">
                              <select
                                className="form-select"
                                value={frequencies[item.id] || "Weekly"} // Load from state or default to "Weekly"
                                onChange={(e) =>
                                  handleFrequencyChange(item.id, e)
                                }
                              >
                                <option value="weekly">Weekly</option>
                                <option value="monthly">Monthly</option>
                                <option value="quaterly">Quarterly</option>
                                <option value="twice-per-year">
                                  Twice per month
                                </option>
                                <option value="once-per-year">
                                  Once per month
                                </option>
                              </select>
                            </td>
                            <td className="px-3 py-2">
                              <button
                                onClick={() => handleDelete(item.id)}
                                className="btn btn-danger bg-main-600"
                              >
                                <i className="ph ph-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>

                {/* Mobile View (shown only on mobile) */}
                <div className="d-block d-md-none">
                  {storedRFQList.length > 0 &&
                    storedRFQList.map((item, index) => (
                      <div key={item.id} className="card mb-3 p-3">
                        <div className="row g-3">
                          {/* Image and Product Name */}
                          <div className="col-12 d-flex align-items-start gap-3">
                            <img
                              src={item?.image}
                              alt=""
                              style={{
                                width: "60px",
                                height: "60px",
                                objectFit: "cover",
                              }}
                              className="rounded"
                            />
                            <div>
                              <h6 className="fw-semibold mb-0">{item.name}</h6>
                            </div>
                          </div>

                          {/* Quantity Controls */}
                          <div className="col-12">
                            <div className="d-flex align-items-center justify-content-between">
                              <span className="fw-semibold">Quantity:</span>
                              <div className="d-flex align-items-center gap-2">
                                <button
                                  className={`w-32 h-32 text-white text-xl flex-center rounded-circle
      ph ph-minus
      ${
        item.quantity === 1
          ? "bg-light-grey cursor-not-allowed"
          : "bg-main-600 hover-bg-main-600 hover-text-white"
      }
    `}
                                  onClick={() => handleDecrement(item.id)}
                                >
                                  -
                                </button>
                                <span className="fw-semibold">
                                  {item.quantity}
                                </span>
                                <button
                                  className="w-32 h-32 text-white text-xl flex-center rounded-circle bg-main-600 hover-bg-main-600 hover-text-white"
                                  onClick={() => handleIncrement(item.id)}
                                >
                                  +
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* Price and Frequency */}
                          <div className="col-6">
                            <div className="d-flex flex-column">
                              <span className="text-muted small">Price:</span>
                              <span className="fw-semibold text-success">
                                {currency} {item.price}
                              </span>
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="d-flex flex-column">
                              <span className="text-muted small">
                                Frequency:
                              </span>
                              <select
                                className="form-select form-select-sm"
                                value={frequencies[item.id] || "Weekly"}
                                onChange={(e) =>
                                  handleFrequencyChange(item.id, e)
                                }
                              >
                                <option value="weekly">Weekly</option>
                                <option value="monthly">Monthly</option>
                                <option value="quaterly">Quarterly</option>
                                <option value="twice-per-year">
                                  Twice per month
                                </option>
                                <option value="once-per-year">
                                  Once per month
                                </option>
                              </select>
                            </div>
                          </div>

                          {/* Delete Button */}
                          <div className="col-12">
                            <button
                              onClick={() => handleDelete(item.id)}
                              className="btn btn-danger btn-sm w-100"
                            >
                              <i className="ph ph-trash me-2"></i>
                              Remove Item
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
                <br></br>
                <label htmlFor="comments" className="form-label fw-semibold">
                  Message
                </label>
                <textarea
                  id="comments"
                  className="form-control"
                  rows="4"
                  placeholder="Enter your message here..."
                  style={{ resize: "none" }}
                  value={cmts}
                  onChange={(e) => setCmts(e.target.value)}
                ></textarea>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                <div className="py-xl-4">
                  <h4 className="text-blue ack mb-8">
                    To how many locations you need the products delivered?
                  </h4>
                  <div className="mb-3">
                    <label
                      htmlFor="locationSelect"
                      className="lable-font form-label fw-semibold"
                    >
                      Select Location
                    </label>
                    <select
                      id="locationSelect"
                      className="input-font form-select"
                      value={locat}
                      onChange={(e) => setLocat(e.target.value)}
                    >
                      <option value="1">1 Location</option>
                      <option value="2">2 Location</option>
                      <option value="3 - 5 locations">3-5 Location</option>
                      <option value="6 - 15 locations">6-15 Location</option>
                      <option value="16 - 50 locations">16-50 Location</option>
                      <option value="more than 50 locations">
                        50 Location or more
                      </option>
                    </select>
                  </div>
                  <br></br>
                  <div className="d-flex align-items-center gap-6">
                    <input
                      type="checkbox"
                      id="helpCheckbox"
                      className="input-font form-check-input "
                      checked={help}
                      onChange={(e) => setHelp(e.target.checked)}
                    />
                    <label htmlFor="helpCheckbox" className="form-check-label">
                      I need help with defining the quantities
                    </label>
                  </div>
                  <hr></hr>
                  <h5>Your Contact</h5>
                  <div className="mb-3">
                    <label
                      htmlFor="comp_name"
                      className="lable-font form-label fw-semibold"
                    >
                      Company name
                    </label>
                    <input
                      type="text"
                      id="company_name"
                      className="input-font form-control"
                      name="company_name"
                      value={compname}
                      onChange={(e) => setCompname(e.target.value)}
                    />
                  </div>

                  {/* Second Input Field with Label */}
                  <div className="mb-3">
                    <label
                      htmlFor="contact_per_name"
                      className="lable-font form-label fw-semibold"
                    >
                      Contact person name
                    </label>
                    <input
                      type="text"
                      id="contact_person_name"
                      className="input-font form-control"
                      name="contact_person_name"
                      value={contperson}
                      onChange={(e) => setContperson(e.target.value)}
                    />
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    {/* Area Code Dropdown */}
                    <div className="flex-grow-1">
                      <label
                        htmlFor="areaCode"
                        className="lable-font form-label fw-semibold"
                      >
                        Area Code
                      </label>
                      <select
                        id="areaCode"
                        className="input-font form-select w-100"
                        value={areacode}
                        onChange={(e) => setAreacode(e.target.value)}
                      >
                        <option value="+971">+971</option>
                        <option value="+974">+974</option>
                        <option value="+968">+968</option>
                      </select>
                    </div>

                    {/* Phone Number Input */}
                    <div className="flex-grow-1">
                      <label
                        htmlFor="phoneNumber"
                        className="lable-font form-label fw-semibold"
                      >
                        Phone Number
                      </label>
                      <input
                        type="text"
                        id="phoneNumber"
                        className="input-font form-control w-100"
                        placeholder="Enter phone number"
                        value={phno}
                        onChange={(e) => {
                          const onlyNumbers = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                          setPhno(onlyNumbers);
                        }}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault(); // Prevent entering non-numeric characters
                          }
                        }}
                        maxLength={9} // Limit input to 9 digits
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="email"
                    className="lable-font form-label fw-semibold"
                  >
                    E-mail address
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="input-font form-control"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <br></br>
                <div className="mb-3"></div>
                <button
                  onClick={collectRFQData}
                  className="btn bg-main-product-50 hover-bg-main-product-50 align-items-center w-100 mt-2"
                >
                  Send request for quote
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default RfqComponent;
